import {LinkService} from '../../i18n/link.service'
import {CategoryLandingPageFieldsFragment} from '../../../../__generated__/datocms.types'
import {DynamicCategoryLandingPage, DynamicCategoryLandingPageContent} from '../types/category-landing-page.types'
import {validateDatoCmsTypes} from './common.serde'
import {parseAsset2} from './asset.serde'
import {parsePageMeta} from './seo.serde'
import {parseIndustrySection} from './industry-section.serde'
import {parseInspirationSection} from './inspiration-section.serde'
import {parsePartnerSection} from './partner-section.serde'
import {parsePromotionalBannerSection} from './promotional-banner-section.serde'
import {parseReviewSection} from './review-section.serde'
import {parseServicesSection} from './services-section.serde'
import {parseSupportSection} from './support-section.serde'
import {parseKnowledgeSection} from './knowledge-section.serde'
import {parsePresentationSection} from './presentation-section.serde'
import {parseOfferingsSection} from './offerings-section.serde'
import {parseHowItWorksSection} from './how-it-works-section.serde'
import {parseContentSection} from './content-section.serde'
import {parseProDirectorySection} from './pro-directory-section.serde'
import {parseSignupSection} from './signup-section.serde'
import {parseCallToAction} from './call-to-action.serde'
import {parseIFrameSection} from './iframe-section.serde'
import {parseVideoSection} from './video-section.serde'

export function parseCategoryLandingPage(
  linkService: LinkService,
  e: CategoryLandingPageFieldsFragment,
): DynamicCategoryLandingPage {
  const entry = validateDatoCmsTypes(e)

  const sections: DynamicCategoryLandingPageContent[] = entry.sections
    ?.map((c): DynamicCategoryLandingPageContent | undefined => {
      switch (c?.__typename) {
        case 'IndustrySectionModelRecord':
          return parseIndustrySection(linkService, c)
        case 'InspirationSectionModelRecord':
          return parseInspirationSection(c)
        case 'PartnerSectionModelRecord':
          return parsePartnerSection(linkService, c)
        case 'PromotionBannerModelRecord':
          return parsePromotionalBannerSection(c)
        case 'ReviewSectionModelRecord':
          return parseReviewSection(c)
        case 'ServicesSectionModelRecord':
          return parseServicesSection(c)
        case 'SupportSectionModelRecord':
          return parseSupportSection(c)
        case 'KnowledgeSectionModelRecord':
          return parseKnowledgeSection(c)
        case 'PresentationSectionModelRecord':
          return parsePresentationSection(c)
        case 'OfferingSectionModelRecord':
          return parseOfferingsSection(linkService, c)
        case 'HowItWorksSectionModelRecord':
          return parseHowItWorksSection(c)
        case 'FieldContentSectionModelRecord':
          return parseContentSection(c)
        case 'FieldDynamicProDirectorySectionModelRecord':
          return parseProDirectorySection(c)
        case 'FieldSignupSectionRecord':
          return parseSignupSection(c)
        case 'FieldIframeSectionRecord':
          return parseIFrameSection(c)
        case 'VideoSectionRecord':
          return parseVideoSection(c)
        default: {
          return undefined
        }
      }
    })
    .filter((c): c is DynamicCategoryLandingPageContent => !!c)

  return {
    title: entry.title,
    description: entry.description,
    primaryCallToAction: entry.primaryCallToAction ? parseCallToAction(entry.primaryCallToAction) : undefined,
    secondaryCallToAction: entry.secondaryCallToAction ? parseCallToAction(entry.secondaryCallToAction) : undefined,
    bannerImage: parseAsset2(entry.bannerImage),
    showPartnershipSection: entry.showPartnershipSection,
    partnershipImage: entry.partnershipImage ? parseAsset2(entry.partnershipImage) : undefined,
    meta: parsePageMeta(linkService, entry.seo, entry._locales),
    sections,
  }
}
